export const termsText = `
RULES AND REGULATIONS

Article 1
General Provisions

1. These Rules and Regulations define the terms and conditions of provision of the Services by FANADISE with the use "Trait Swap" application.
2. The terms below shall have the following meanings as defined in these Rules and Regulations:

a. Application – "Trait Swap" application via which FANADISE shall provide the Services.
b. Features – features of bears depicted in the Fancy Bear Metaverse Tokens – such as: fur colour, eyes, facial expression, various additions and clothes, background colour, etc.
c. Cookies – means information technology data, specifically including small text files that are saved and stored on devices on which the Customer uses the Application.
d. Business Days – a period from Monday through Friday, except for holidays – in compliance with the regulations of law applicable in the territory of the Republic of Poland.
e. Customer – a person using the Application, who is a natural person with full legal capacity (i.e., as a rule, who is 18 years of age or older), a legal person or an organisational unit that has no corporate existence to which an act of law grants legal capacity.
f. Customer Content – any Content that is transmitted to FANADISE by the Customer further to the use of the Services available in the Application. Customer Content may especially include: audio recordings, information, data, texts, software, music, sounds, pictures, graphics, video, news, 3D models, or other materials. The configuration of the Features added to the Original Tokens in the process of creating New Tokens shall also be considered as Customer, as well as any other elements of New Tokens, as provided by the Customer.
g. Cryptocurrency Wallet, Wallet – a place in which the Customer stores their private keys to the NFT Tokens.
h. IP Rights, IP – any intellectual property rights, including, but not limited to copyright, industrial property rights (patents, protective rights to utility designs, rights under registered industrial designs, rights to non-registered industrial designs, protective rights to trade marks, etc.), sui generis rights to databases, rights to the image, know-how, etc.
i. Rules and Regulations – these Rules and Regulations.
j. NFT Tokens, NFT – non-fungible tokens created with the use of blockchain technology, and connected with specific digital content (e.g. graphics, animation, 3D model, etc.). NFT are non-exchangeable, therefore are unique.
k. FBM Tokens, Fancy Bear Metaverse Tokens – NFT Tokens belonging to a "Fancy Bear Metaverse" collection – characterised by unique pictures presenting bears with unique Features. There are rights attached to each FBM Token have been described in detail at the website accessible at the following address: https://www.fancybearsmetaverse.com/ (e.g. an opportunity to participate in online events, the right to participate in lotteries, attractive discounts for specific goods/services, etc.).
l. Agreement – an agreement on provision of a Service that is entered into by the Customer with FANADISE under the terms and conditions specified in the Rules and Regulations.
m. Device – means an electronic device on which the Customer gains access to the Application.
n. Service Provider, Administrator, FANADISE – FANADISE sp. z o.o., with its registered office in Warsaw at the following address Aleje Jerozolimskie 94, 00-807 Warszawa, POLAND, entered into the register of entrepreneurs in the National Court Register under No. 0000910932, REGON (Statistical Identification Number): 389437362, NIP (Tax Identification Number): 7011043442, email: info@fanadise.com.
o. Services – services provided by FANADISE to the Customer by means of Trait Swap Application, including the Trade Swap Service.
p. Trait Swap Service – a service provided by FANADISE to the Customer, who is an owner of the FBM Token, by means of Trait Swap Application. Under the FBM Service FANADISE shall create a copy of a specific FBM Token ("Original Token"), modified by adding Features selected by the Customer, and shall also transfer the rights to such a new FBM Token ("New Token") to the Customer in exchange for specific remuneration.

Article 2
Terms and Conditions of Using the Application

1. FANADISE shall provide the Customers by means of the Application with an opportunity of using a number of services provided by electronic means (within the meaning of the Act on Providing Services by Electronic Means of 18 July 2002; hereinafter: APSEM), as indicated further in the provisions herein below.
2. FANADISE shall make available the following Services, free of charge, to the Customers by means of the Application:

1. making available the Application content,
2. linking a selected Cryptocurrency Wallet with the Application,
3. entering into agreements on provision of Services with FANADISE.

1. Irrespective of the above, FANADISE shall make available to the Customers a possibility of paid use of the Trait Swap Service by means of the Application.
2. In order to use the Services the Customer should have a device that at least: allows connecting to the Internet and with an operating system, an Internet connection, the required software (a web browser), an electronic mail account, and also a Cryptocurrency Waller in the case of the Trait Swap Service.
3. Entering into agreements on provision of Services shall be executed by means of a relevant notice made by the Customer requesting data transmission over a telecommunication network (which may occur in the case of the Services referred to in Article 2.2 of the Rules and Regulations by opening the Application, and in the case of the Trait Swap Service by completing and approving a relevant form within the Application). The agreements in question shall expire following their full performance.
4. The Customer undertakes that during the use of the Application they shall refrain from undertaking illegal activities or those that may be to the detriment of FANADISE’s renown, in particular, they shall not:

1. use the Application in a manner that would promote business activities pursued by entities competitive to FANADISE or other third parties,
2. undertake actions that may disrupt operations of the Application, especially by means of: (i) hacking or assisting in hacking the Application, which shall be understood to mean especially a DDoS attack, "griefing attack", "sybil attack"; (ii) stealing or assisting in stealing the NFC Tokens,
3. infringe the rights or moral rights of other Customers,
4. undertake attempts at bypassing the Application’s mechanisms,
5. engage or facilitate for third parties to engage in any activities related to the NFT Tokens that violate the principles of fair competition or constitute unfair trade practices which are considered to include in particular:

1. trading in NFT at prices lower or higher than market ones to influence the NFT market price or to determine a price that does not reflect the actual market condition of such NFT;
2. creating alleged activities in relation to the market of non-financial transactions with the use of NFT, including the performance of or causing the performance of an apparent activity;
3. executing or facilitating execution of transactions on any collective account for the purpose of influencing the NFT market price;

1. disseminate untrue information, especially about the rules of operations of FANADISE, including by means of the Application.

1. If it has been established that FANADISE does not perform a service or performs it inappropriately, the Customer shall have a possibility of lodging a complaint by registered mail or electronic mail sent to the following address: info@fanadise.com . A complaint shall specify at least: a) the Customer’s particulars, b) an exact description of a reason for the complaint, and c) indication of the Customer’s demand. The Customer shall be notified about how their complaint has been handled within 14 days from its receipt by FANADISE. (mailto:bok@asport.pl)

Article 3
Trait Swap Service

1. Using the Trait Swap Service by the Customer shall be conditional upon:

1. having a Cryptocurrency Wallet that should be linked to the Application.
2. approving the content of the Rules and Regulations, especially while using the Cryptocurrency Wallet.
3. having an ownership title at least to one Fancy Bear Metaverse Token.

1. In order to use the Service the Customer shall:

1. choose a Fancy Bear Metaverse Token that shall be a subject of the Service (Original Token).
2. select one or more Features available in the Application that shall be assigned to the Original Token – which will cause creation of a New Token.
3. approve execution of transactions pursuant to the terms and conditions displayed in the Application, in particular, in exchange for payment of indicated remuneration.

1. In performing the Trait Swap Service, FANADISE undertakes to:

1. create a New Token that is a copy of the Original Token that has been modified by adding a Feature or Features selected by the Customer.
2. transfer the rights to a New Token onto the Customer by means of using the Cryptocurrency Wallet indicated by the Customer.

1. Under the rights it has FANADISE expresses its consent to the Customer use of a New Token in a similar way in which they could have used the Original Token while taking into consideration the existing constraints especially provided for under a smart contract for the Original Token, etc.

Article 4
Intellectual Property Rights

1. The Customer shall grant to FANADISE a license for the independent use of any Customer Content by FANADISE that is subject to the IP Rights, issued to FANADISE by the Customer further to their use of the Application, especially during performance of the Services (hereinafter: Works) – in any existing fields of exploitation, without any time or territorial constraints. In particular, this includes the right to:

1. fix and reproduce the Works with the use of any technology,
2. trade in the Works, as well as renting and letting for use of their copies,
3. disseminate the Works by means of any technology, including, but not limited to making them available in such a manner that anyone could have access to them in a place and at a time of their choice (in the Internet),
4. modify, change their layout or make any changes in the Works,
5. perform and disseminate derivative works of the Works,
6. register the Works as objects of the industrial property rights, including, but not limited to trade marks, industrial designs, etc.

1. The Customer undertakes that they shall not terminate the above license nor shall they undertake any other actions to have it terminated. In the case of the Works that have been used as elements of NFT Tokens, the license shall not expire in any case during the period of existence of any of such NFT Tokens.
2. The Customer undertakes that moral rights to the Works shall not be exercised by their creator or creators (who could be the Customer or a third person) throughout the terms of the license that is referred to in the preceding sections. This shall particularly apply to: the right to authorship, the right of integrity and the right to take a decision on first publication, the right to the Work’s reputation etc.
3. FANADISE shall be entitled to transfer the rights and obligations under the license that has been granted hereunder, as well as to grant sublicenses to third parties to use the Works.
4. The Parties mutually agree that none of the provisions of the Agreement shall be understood as a transfer of any IP Rights by one of the Parties onto the other Party. In particular, FANADISE shall retain all of the IP Rights to the Application and all of its elements, including texts, graphics, videos, offered Features, etc.

Article 5
Third Party Rights

1. The Customer represents that the use of any Customer Content by FANADISE (including both the Works and Content that are not objects of the IP Rights) shall not constitute an infringement of third party rights or moral rights that third parties are entitled to. Consequently, the Customer represents that:

1. it has the IP Rights to the Customer Content to the extent necessary for the performance of the obligations under the Agreement,
2. the Customer Content does not infringe the IP Rights, nor any other rights or moral rights of third parties,
3. the Customer Content does not contain:

1. illegal content that is deemed to include especially content that is libellous, pornographic, aimed at disturbing public order or commonly accepted rules of ethics, discriminatory, incites or aids in committing a crime or an offence, promotes illegal products or services, etc.
2. content promoting goods or services of third parties, especially competitors of FANADISE.
3. content that has or could potentially have illegal consequences – especially malware, ransomeware, viruses, bugs, Trojans, cancelbots, etc.

1. to the best knowledge of the Customer, the above circumstances are not challenged by third parties, including especially in the course of pending court proceedings or negotiations.

1. In the event whereby any of the statements make in the content of the Rules and Regulations, including especially Article 5.1 above, is found to be untrue, the Customer commits to:

1. undertake actions necessary to allow FANADISE further use of the Customer Content to the extent provided for in the Rules and Regulations, including acquisition of the right for FANADISE to such content.
2. reimburse any costs further to the Customer’s statements being untrue incurred by FANADISE and also by: (i) entities related to FANADISE (parent or subsidiary companies), (ii) representatives or employees of FANADISE or (iii) business partners of FANADISE – particularly by way of claims submitted by third parties. This shall especially include any amounts paid by FANADISE to third parties for the purpose of payments for the submitted claims (including, but not limited to payments of remuneration, license fees, compensation for unlawfully obtained benefits, etc.), reimbursement of the costs of proceedings, reimbursement of the costs of legal assistance, etc.

1. The Parties further commit that in the event referred to in Article 5.2 they shall undertake joint mutual co-operation to conduct defence against claims of a third party, including their mutual agreement on any required documentation.
2. In the event whereby FANADISE has received an official notification or reliable information about an unlawful nature of the stored content delivered by the Customer, FANADISE may prevent access to such content.

Article 6
Personal Data Protection

1. FANADISE is the Controller of the Customer’s personal data. The Customers may contact FANADISE in matters relating to the protection of personal data by means of electronic mail using the following email address: info@fanadise.com (mailto:info@fanadise.com) .
2. The Customer’s personal data shall processed by FANADISE in accordance with the generally applicable regulations (including: Regulation (EU) no. 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC - hereinafter referred to as GDPR) - throughout a period of conducting activities aimed at the implementation of purposes further to which they have been collected.
3. FANADISE shall process personal data of Customers for the purpose of:

1. the performance of agreements on the provision of the Services – especially, including the Trait Swap Service. In such event the processing shall be based on the performance of an agreement with the Customer or actions that are undertaken upon the Customer’s request prior to entering into an agreement (Article 6(1)(b) of GDPR).
2. execution of legal obligations to which FANADISE is a subject, in particular with regard to the maintenance of accounting documentation (Article 6(1)(c) of GDPR).
3. promotion of own goods or services, and also for the purpose of preparing summaries, analyses, and statistics and seeking claims. In such event the processing shall be based on a legitimate interest of FANADISE (Article 6(1)(f) of GDPR).

1. The data may also be processed by the Controller to a larger extent on the basis of consent given (Article 6(1)(a) of GDPR). In such event, a data subject shall have the right to withdraw consent at any time – without affecting the lawfulness of processing based on consent before its withdrawal. The data shall be processed over a period that is provided for in the content of consent (or until consent withdrawal, irrespective of which has occurred earlier).
2. In each case the disclosure of personal data by the Customer shall be voluntary subject to a reservation that certain data are necessary for FANADISE for the performance of agreements concluded by means of the Application.
3. The Customer’s personal data may be made available to third-party entities solely for the purpose whereby FANADISE is authorised or obligated to do so under regulations of law. Data recipients may particularly include: persons supporting information technology infrastructure or systems, sub-contractors, persons providing services related to the execution or improvement of a sales process (e.g. payment intermediaries, banks, advertising agencies), and also advisors (e.g. in the field of accounting support or legal assistance) or auditors.
4. Personal data shall not be processed in a manner that constitutes profiling.
5. Personal data may be transmitted by the Controller to third countries (outside the territory of the European Economic Area). In such event, data shall be secured in a manner required by generally applicable regulations, especially by means of applying so-called Standard Contractual Clauses (SCC).
6. The Customer shall have the right to access their personal data, their rectification, erasure, or restriction of their processing and the right to object to processing, and also the right to data portability. The Customer shall have the right to object to processing especially in the event whereby there are no grounds for the processing of data or when the data are processed for the purposes of direct marketing.
7. In the event whereby the processing is performed in an infringement of law, the Customer shall have the right to lodge a complaint with a supervisory authority – the President of the Personal Data Protection Office.

Article 7
Cookies

1. By using Cookies FANADISE shall store information on the Customer’s Device or shall obtained access to the information that is already stored pursuant to the terms and conditions defined in the Rules and Regulations.
2. FANADISE shall use the following types of Cookies:

1. Session Cookies: are stored on the Customer’s Device and shall remain there until the end of a session. Saved information is then permanently deleted from the Device’s memory.
2. Persistent Cookies: are stored on the Customer’s Device and shall remain there until they have been deleted. A session end in a given browser or switching the Device off shall not result in their deletion from the Device.

1. FANADISE uses its Own Cookies for the purpose of adjusting the Application content to the Customer’s preferences and needs, especially while considering a type of the Device with which the Customer uses the Application.
2. FANADISE shall use External Cookies to prepare aggregate statistics and analyses used to monitor the way in which Customers use the Application which provides for its adjustment to the Customers’ needs as much as possible.
3. The use of Cookies by FANADISE shall not result in a change of the set-up of the Customer’s Device or the software that has been installed on such Device.
4. The Customer may delete Cookies at any time or restrict their use.
5. The restriction in the use of Cookies or the deletion of the existing Cookies may affect certain functionalities available in the Application.

Article 8
Amendments to the Rules and Regulations

1. FANADISE shall have the right to amend the provisions of the Rules and Regulations.
2. In no way shall amendments to the Rules and Regulations infringe upon the rights acquired by the Customers; especially they shall have no impact on orders that have already been submitted for the performance of the Services that shall be carried out pursuant to the existing principles.

Article 9
Final Provisions

1. These Rules and Regulations and any contracts that have been concluded pursuant to them (especially agreements on the provision of the Services) shall be governed by Polish laws.
2. As from 15 February the European Commission has launched an online platform (ODR) for resolving disputes between consumers and traders at the European Union level that is available at the following address: http://ec.europa.eu/consumers/odr. The electronic mail address of FANADISE, as a prospective point of contact in those matters, is: info@fanadise.com (mailto:info@fanadise.com) .
`;

export const termsHTML = `
<style>
 ol {
  padding-left: 1em;
 }
</style>
<p style="text-align: center">
  <strong>RULES AND REGULATIONS</strong>
</p>
<br />
<p style="text-align: center">
  <strong>
    Article 1
    <br />
    General Provisions
  </strong>
</p>
<ol>
  <li>
    These Rules and Regulations define the terms and conditions of provision of
    the Services by FANADISE with the use "Trait Swap" application.
  </li>
  <li>
    The terms below shall have the following meanings as defined in these Rules
    and Regulations:
  </li>
</ol>
<ol type="a">
  <li>
    <strong>Application</strong>
    – "Trait Swap" application via which FANADISE shall provide the Services.
  </li>
  <li>
    <strong>Features</strong>
    – features of bears depicted in the Fancy Bear Metaverse Tokens
    <strong> – </strong>such as: fur colour, eyes, facial expression, various
    additions and clothes, background colour, etc.
  </li>
  <li>
    <strong>Cookies</strong>
    – means information technology data, specifically including small text files
    that are saved and stored on devices on which the Customer uses the
    Application.
  </li>
  <li>
    <strong>Business Days</strong>
    – a period from Monday through Friday, except for holidays – in compliance
    with the regulations of law applicable in the territory of the Republic of
    Poland.
  </li>
  <li>
    <strong>Customer</strong>
    – a person using the Application, who is a natural person with full legal
    capacity (i.e., as a rule, who is 18 years of age or older), a legal person
    or an organisational unit that has no corporate existence to which an act of
    law grants legal capacity.
  </li>
  <li>
    <strong>Customer Content</strong>
    – any Content that is transmitted to FANADISE by the Customer further to the
    use of the Services available in the Application. Customer Content may
    especially include: audio recordings, information, data, texts, software,
    music, sounds, pictures, graphics, video, news, 3D models, or other
    materials. The configuration of the Features added to the Original Tokens in
    the process of creating New Tokens shall also be considered as Customer, as
    well as any other elements of New Tokens, as provided by the Customer.
  </li>
  <li>
    <strong></strong>
    <strong>Cryptocurrency Wallet, Wallet</strong>
    – a place in which the Customer stores their private keys to the NFT Tokens.
  </li>
  <li>
    <strong>IP Rights, IP</strong>
    – any intellectual property rights, including, but not limited to copyright,
    industrial property rights (patents, protective rights to utility designs,
    rights under registered industrial designs, rights to non-registered
    industrial designs, protective rights to trade marks, etc.),
    <em>sui generis</em> rights to databases, rights to the image, know-how,
    etc.
  </li>
  <li>
    <strong>Rules and Regulations</strong>
    – these Rules and Regulations.
  </li>
  <li>
    <strong>NFT Tokens, NFT</strong>
    – non-fungible tokens created with the use of blockchain technology, and
    connected with specific digital content (e.g. graphics, animation, 3D model,
    etc.). NFT are non-exchangeable, therefore are unique.
  </li>
  <li>
    <strong>FBM Tokens, Fancy Bear Metaverse Tokens</strong>
    – NFT Tokens belonging to a "Fancy Bear Metaverse" collection –
    characterised by unique pictures presenting bears with unique Features.
    There are rights attached to each FBM Token have been described in detail at
    the website accessible at the following address:
    <a href="https://www.fancybearsmetaverse.com/">
      https://www.fancybearsmetaverse.com/
    </a>
    (e.g. an opportunity to participate in online events, the right to
    participate in lotteries, attractive discounts for specific goods/services,
    etc.).
  </li>
  <li>
    <strong>Agreement</strong>
    – an agreement on provision of a Service that is entered into by the
    Customer with FANADISE under the terms and conditions specified in the Rules
    and Regulations.
  </li>
  <li>
    <strong>Device</strong>
    – means an electronic device on which the Customer gains access to the
    Application.
  </li>
  <li>
    <strong>Service Provider, Administrator, FANADISE</strong>
    – FANADISE sp. z o.o., with its registered office in Warsaw at the following
    address Aleje Jerozolimskie 94, 00-807 Warszawa, POLAND, entered into the
    register of entrepreneurs in the National Court Register under No.
    0000910932, REGON (Statistical Identification Number): 389437362, NIP (Tax
    Identification Number): 7011043442, email: info@fanadise.com.
  </li>
  <li>
    <strong>Services</strong>
    – services provided by FANADISE to the Customer by means of Trait Swap
    Application, including the Trade Swap Service.
  </li>
  <li>
    <strong>Trait Swap Service</strong>
    – a service provided by FANADISE to the Customer, who is an owner of the FBM
    Token, by means of Trait Swap Application. Under the FBM Service FANADISE
    shall create a copy of a specific FBM Token ("Original Token"), modified by
    adding Features selected by the Customer, and shall also transfer the rights
    to such a new FBM Token ("New Token") to the Customer in exchange for
    specific remuneration.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 2</strong>
</p>
<p style="text-align: center">
  <strong>Terms and Conditions of Using the Application</strong>
</p>
<ol>
  <li>
    FANADISE shall provide the Customers by means of the Application with an
    opportunity of using a number of services provided by electronic means
    (within the meaning of the Act on Providing Services by Electronic Means of
    18 July 2002; hereinafter: APSEM), as indicated further in the provisions
    herein below.
  </li>
  <li>
    FANADISE shall make available the following Services, free of charge, to the
    Customers by means of the Application:
  </li>
</ol>
<ol>
  <li>making available the Application content,</li>
  <li>linking a selected Cryptocurrency Wallet with the Application,</li>
  <li>entering into agreements on provision of Services with FANADISE.</li>
</ol>
<ol>
  <li>
    Irrespective of the above, FANADISE shall make available to the Customers a
    possibility of paid use of the Trait Swap Service by means of the
    Application.
  </li>
  <li>
    In order to use the Services the Customer should have a device that at
    least: allows connecting to the Internet and with an operating system, an
    Internet connection, the required software (a web browser), an electronic
    mail account, and also a Cryptocurrency Waller in the case of the Trait Swap
    Service.
  </li>
  <li>
    Entering into agreements on provision of Services shall be executed by means
    of a relevant notice made by the Customer requesting data transmission over
    a telecommunication network (which may occur in the case of the Services
    referred to in Article 2.2 of the Rules and Regulations by opening the
    Application, and in the case of the Trait Swap Service by completing and
    approving a relevant form within the Application). The agreements in
    question shall expire following their full performance.
  </li>
  <li>
    The Customer undertakes that during the use of the Application they shall
    refrain from undertaking illegal activities or those that may be to the
    detriment of FANADISE’s renown, in particular, they shall not:
  </li>
</ol>
<ol>
  <li>
    use the Application in a manner that would promote business activities
    pursued by entities competitive to FANADISE or other third parties,
  </li>
  <li>
    undertake actions that may disrupt operations of the Application, especially
    by means of: (i) hacking or assisting in hacking the Application, which
    shall be understood to mean especially a DDoS attack, "griefing attack",
    "sybil attack"; (ii) stealing or assisting in stealing the NFC Tokens,
  </li>
  <li>infringe the rights or moral rights of other Customers,</li>
  <li>undertake attempts at bypassing the Application’s mechanisms,</li>
  <li>
    engage or facilitate for third parties to engage in any activities related
    to the NFT Tokens that violate the principles of fair competition or
    constitute unfair trade practices which are considered to include in
    particular:
  </li>
</ol>
<ol>
  <li>
    trading in NFT at prices lower or higher than market ones to influence the
    NFT market price or to determine a price that does not reflect the actual
    market condition of such NFT;
  </li>
  <li>
    creating alleged activities in relation to the market of non-financial
    transactions with the use of NFT, including the performance of or causing
    the performance of an apparent activity;
  </li>
  <li>
    executing or facilitating execution of transactions on any collective
    account for the purpose of influencing the NFT market price;
  </li>
</ol>
<ol>
  <li>
    disseminate untrue information, especially about the rules of operations of
    FANADISE, including by means of the Application.
  </li>
</ol>
<ol>
  <li>
    If it has been established that FANADISE does not perform a service or
    performs it inappropriately, the Customer shall have a possibility of
    lodging a complaint by registered mail or electronic mail sent to the
    following address: info@fanadise.com
    <a href="mailto:bok@asport.pl">
      . A complaint shall specify at least: a) the Customer’s particulars, b) an
      exact description of a reason for the complaint, and c) indication of the
      Customer’s demand. The Customer shall be notified about how their
      complaint has been handled within 14 days from its receipt by FANADISE.
    </a>
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 3</strong>
</p>
<p style="text-align: center">
  <strong>Trait Swap Service</strong>
</p>
<ol>
  <li>
    Using the Trait Swap Service by the Customer shall be conditional upon:
  </li>
</ol>
<ol>
  <li>
    having a Cryptocurrency Wallet that should be linked to the Application.
  </li>
  <li>
    approving the content of the Rules and Regulations, especially while using
    the Cryptocurrency Wallet.
  </li>
  <li>having an ownership title at least to one Fancy Bear Metaverse Token.</li>
</ol>
<ol>
  <li>In order to use the Service the Customer shall:</li>
</ol>
<ol>
  <li>
    choose a Fancy Bear Metaverse Token that shall be a subject of the Service
    (Original Token).
  </li>
  <li>
    select one or more Features available in the Application that shall be
    assigned to the Original Token – which will cause creation of a New Token.
  </li>
  <li>
    approve execution of transactions pursuant to the terms and conditions
    displayed in the Application, in particular, in exchange for payment of
    indicated remuneration.
  </li>
</ol>
<ol>
  <li>In performing the Trait Swap Service, FANADISE undertakes to:</li>
</ol>
<ol>
  <li>
    create a New Token that is a copy of the Original Token that has been
    modified by adding a Feature or Features selected by the Customer.
  </li>
  <li>
    transfer the rights to a New Token onto the Customer by means of using the
    Cryptocurrency Wallet indicated by the Customer.
  </li>
</ol>
<ol>
  <li>
    Under the rights it has FANADISE expresses its consent to the Customer use
    of a New Token in a similar way in which they could have used the Original
    Token while taking into consideration the existing constraints especially
    provided for under a smart contract for the Original Token, etc.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 4</strong>
</p>
<p style="text-align: center">
  <strong>Intellectual Property Rights</strong>
</p>
<ol>
  <li>
    The Customer shall grant to FANADISE a license for the independent use of
    any Customer Content by FANADISE that is subject to the IP Rights, issued to
    FANADISE by the Customer further to their use of the Application, especially
    during performance of the Services (hereinafter: <strong>Works</strong>) –
    in any existing fields of exploitation, without any time or territorial
    constraints. In particular, this includes the right to:
  </li>
</ol>
<ol>
  <li>fix and reproduce the Works with the use of any technology,</li>
  <li>
    trade in the Works, as well as renting and letting for use of their copies,
  </li>
  <li>
    disseminate the Works by means of any technology, including, but not limited
    to making them available in such a manner that anyone could have access to
    them in a place and at a time of their choice (in the Internet),
  </li>
  <li>modify, change their layout or make any changes in the Works,</li>
  <li>perform and disseminate derivative works of the Works,</li>
  <li>
    register the Works as objects of the industrial property rights, including,
    but not limited to trade marks, industrial designs, etc.
  </li>
</ol>
<ol>
  <li>
    The Customer undertakes that they shall not terminate the above license nor
    shall they undertake any other actions to have it terminated. In the case of
    the Works that have been used as elements of NFT Tokens, the license shall
    not expire in any case during the period of existence of any of such NFT
    Tokens.
  </li>
  <li>
    The Customer undertakes that moral rights to the Works shall not be
    exercised by their creator or creators (who could be the Customer or a third
    person) throughout the terms of the license that is referred to in the
    preceding sections. This shall particularly apply to: the right to
    authorship, the right of integrity and the right to take a decision on first
    publication, the right to the Work’s reputation etc.
  </li>
  <li>
    FANADISE shall be entitled to transfer the rights and obligations under the
    license that has been granted hereunder, as well as to grant sublicenses to
    third parties to use the Works.
  </li>
  <li>
    The Parties mutually agree that none of the provisions of the Agreement
    shall be understood as a transfer of any IP Rights by one of the Parties
    onto the other Party. In particular, FANADISE shall retain all of the IP
    Rights to the Application and all of its elements, including texts,
    graphics, videos, offered Features, etc.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 5</strong>
</p>
<p style="text-align: center">
  <strong>Third Party Rights</strong>
</p>
<ol>
  <li>
    The Customer represents that the use of any Customer Content by FANADISE
    (including both the Works and Content that are not objects of the IP Rights)
    shall not constitute an infringement of third party rights or moral rights
    that third parties are entitled to. Consequently, the Customer represents
    that:
  </li>
</ol>
<ol>
  <li>
    it has the IP Rights to the Customer Content to the extent necessary for the
    performance of the obligations under the Agreement,
  </li>
  <li>
    the Customer Content does not infringe the IP Rights, nor any other rights
    or moral rights of third parties,
  </li>
  <li>the Customer Content does not contain:</li>
</ol>
<ol>
  <li>
    illegal content that is deemed to include especially content that is
    libellous, pornographic, aimed at disturbing public order or commonly
    accepted rules of ethics, discriminatory, incites or aids in committing a
    crime or an offence, promotes illegal products or services, etc.
  </li>
  <li>
    content promoting goods or services of third parties, especially competitors
    of FANADISE.
  </li>
  <li>
    content that has or could potentially have illegal consequences – especially
    malware, ransomeware, viruses, bugs, Trojans, cancelbots, etc.
  </li>
</ol>
<ol>
  <li>
    to the best knowledge of the Customer, the above circumstances are not
    challenged by third parties, including especially in the course of pending
    court proceedings or negotiations.
  </li>
</ol>
<ol>
  <li>
    In the event whereby any of the statements make in the content of the Rules
    and Regulations, including especially Article 5.1 above, is found to be
    untrue, the Customer commits to:
  </li>
</ol>
<ol>
  <li>
    undertake actions necessary to allow FANADISE further use of the Customer
    Content to the extent provided for in the Rules and Regulations, including
    acquisition of the right for FANADISE to such content.
  </li>
  <li>
    reimburse any costs further to the Customer’s statements being untrue
    incurred by FANADISE and also by: (i) entities related to FANADISE (parent
    or subsidiary companies), (ii) representatives or employees of FANADISE or
    (iii) business partners of FANADISE – particularly by way of claims
    submitted by third parties. This shall especially include any amounts paid
    by FANADISE to third parties for the purpose of payments for the submitted
    claims (including, but not limited to payments of remuneration, license
    fees, compensation for unlawfully obtained benefits, etc.), reimbursement of
    the costs of proceedings, reimbursement of the costs of legal assistance,
    etc.
  </li>
</ol>
<ol>
  <li>
    The Parties further commit that in the event referred to in Article 5.2 they
    shall undertake joint mutual co-operation to conduct defence against claims
    of a third party, including their mutual agreement on any required
    documentation.
  </li>
  <li>
    In the event whereby FANADISE has received an official notification or
    reliable information about an unlawful nature of the stored content
    delivered by the Customer, FANADISE may prevent access to such content.
  </li>
</ol>
<p>
  <strong></strong>
  <br />
</p>
<p style="text-align: center">
  <strong>Article 6</strong>
</p>
<p style="text-align: center">
  <strong>Personal Data Protection</strong>
</p>
<ol>
  <li>
    FANADISE is the Controller of the Customer’s personal data. The Customers
    may contact FANADISE in matters relating to the protection of personal data
    by means of electronic mail using the following email address:
    <a href="mailto:info@fanadise.com">info@fanadise.com</a>.
  </li>
  <li>
    The Customer’s personal data shall processed by FANADISE in accordance with
    the generally applicable regulations (including: Regulation (EU) no.
    2016/679 of the European Parliament and of the Council of 27 April 2016 on
    the protection of natural persons with regard to the processing of personal
    data and on the free movement of such data, and repealing Directive 95/46/EC
    - hereinafter referred to as GDPR) - throughout a period of conducting
    activities aimed at the implementation of purposes further to which they
    have been collected.
  </li>
  <li>FANADISE shall process personal data of Customers for the purpose of:</li>
</ol>
<ol>
  <li>
    the performance of agreements on the provision of the Services – especially,
    including the Trait Swap Service. In such event the processing shall be
    based on the performance of an agreement with the Customer or actions that
    are undertaken upon the Customer’s request prior to entering into an
    agreement (Article 6(1)(b) of GDPR).
  </li>
  <li>
    execution of legal obligations to which FANADISE is a subject, in particular
    with regard to the maintenance of accounting documentation (Article 6(1)(c)
    of GDPR).
  </li>
  <li>
    promotion of own goods or services, and also for the purpose of preparing
    summaries, analyses, and statistics and seeking claims. In such event the
    processing shall be based on a legitimate interest of FANADISE (Article
    6(1)(f) of GDPR).
  </li>
</ol>
<ol>
  <li>
    The data may also be processed by the Controller to a larger extent on the
    basis of consent given (Article 6(1)(a) of GDPR). In such event, a data
    subject shall have the right to withdraw consent at any time – without
    affecting the lawfulness of processing based on consent before its
    withdrawal. The data shall be processed over a period that is provided for
    in the content of consent (or until consent withdrawal, irrespective of
    which has occurred earlier).
  </li>
  <li>
    In each case the disclosure of personal data by the Customer shall be
    voluntary subject to a reservation that certain data are necessary for
    FANADISE for the performance of agreements concluded by means of the
    Application.
  </li>
  <li>
    The Customer’s personal data may be made available to third-party entities
    solely for the purpose whereby FANADISE is authorised or obligated to do so
    under regulations of law. Data recipients may particularly include: persons
    supporting information technology infrastructure or systems,
    sub-contractors, persons providing services related to the execution or
    improvement of a sales process (e.g. payment intermediaries, banks,
    advertising agencies), and also advisors (e.g. in the field of accounting
    support or legal assistance) or auditors.
  </li>
  <li>
    Personal data shall not be processed in a manner that constitutes profiling.
  </li>
  <li>
    Personal data may be transmitted by the Controller to third countries
    (outside the territory of the European Economic Area). In such event, data
    shall be secured in a manner required by generally applicable regulations,
    especially by means of applying so-called Standard Contractual Clauses
    (SCC).
  </li>
  <li>
    The Customer shall have the right to access their personal data, their
    rectification, erasure, or restriction of their processing and the right to
    object to processing, and also the right to data portability. The Customer
    shall have the right to object to processing especially in the event whereby
    there are no grounds for the processing of data or when the data are
    processed for the purposes of direct marketing.
  </li>
  <li>
    In the event whereby the processing is performed in an infringement of law,
    the Customer shall have the right to lodge a complaint with a supervisory
    authority – the President of the Personal Data Protection Office.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 7</strong>
</p>
<p style="text-align: center">
  <strong>Cookies</strong>
</p>
<ol>
  <li>
    By using Cookies FANADISE shall store information on the Customer’s Device
    or shall obtained access to the information that is already stored pursuant
    to the terms and conditions defined in the Rules and Regulations.
  </li>
  <li>FANADISE shall use the following types of Cookies:</li>
</ol>
<ol>
  <li>
    Session Cookies: are stored on the Customer’s Device and shall remain there
    until the end of a session. Saved information is then permanently deleted
    from the Device’s memory.
  </li>
  <li>
    Persistent Cookies: are stored on the Customer’s Device and shall remain
    there until they have been deleted. A session end in a given browser or
    switching the Device off shall not result in their deletion from the Device.
  </li>
</ol>
<ol>
  <li>
    FANADISE uses its Own Cookies for the purpose of adjusting the Application
    content to the Customer’s preferences and needs, especially while
    considering a type of the Device with which the Customer uses the
    Application.
  </li>
  <li>
    FANADISE shall use External Cookies to prepare aggregate statistics and
    analyses used to monitor the way in which Customers use the Application
    which provides for its adjustment to the Customers’ needs as much as
    possible.
  </li>
  <li>
    The use of Cookies by FANADISE shall not result in a change of the set-up of
    the Customer’s Device or the software that has been installed on such
    Device.
  </li>
  <li>The Customer may delete Cookies at any time or restrict their use.</li>
  <li>
    The restriction in the use of Cookies or the deletion of the existing
    Cookies may affect certain functionalities available in the Application.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>Article 8</strong>
</p>
<p style="text-align: center">
  <strong>Amendments to the Rules and Regulations</strong>
</p>
<ol>
  <li>
    FANADISE shall have the right to amend the provisions of the Rules and
    Regulations.
  </li>
  <li>
    In no way shall amendments to the Rules and Regulations infringe upon the
    rights acquired by the Customers; especially they shall have no impact on
    orders that have already been submitted for the performance of the Services
    that shall be carried out pursuant to the existing principles.
  </li>
</ol>
<br />
<p style="text-align: center">
  <strong>
    Article 9
    <br />
    Final Provisions
  </strong>
</p>
<ol>
  <li>
    These Rules and Regulations and any contracts that have been concluded
    pursuant to them (especially agreements on the provision of the Services)
    shall be governed by Polish laws.
  </li>
  <li>
    As from 15 February the European Commission has launched an online platform
    (ODR) for resolving disputes between consumers and traders at the European
    Union level that is available at the following address:
    http://ec.europa.eu/consumers/odr. The electronic mail address of FANADISE,
    as a prospective point of contact in those matters, is:
    <a href="mailto:info@fanadise.com">info@fanadise.com</a>.
  </li>
</ol>
`;
